// extracted by mini-css-extract-plugin
module.exports = {"button":"CustomChip_button__0NcFD","buttonDefault":"CustomChip_buttonDefault__sWipb","buttonOutlined":"CustomChip_buttonOutlined__VQA8C","inner":"CustomChip_inner__Z0Rg0"};